import { FETCH_CALCULATION_PARAMETER_RESPONSE, FETCH_CALCULATE_REVENUE_RESPONSE } from './action';

const automatedRevenueReducer = (state = {}, action) => {
    switch (action.type) {
        case FETCH_CALCULATION_PARAMETER_RESPONSE:
            return {
                ...state,
                revenuCalculationParams: action.data.data
            }
        case FETCH_CALCULATE_REVENUE_RESPONSE:
            return {
                ...state,
                revenuCalculationResponse: action.data.data
            }

        default:
            return state
    }
}

export default automatedRevenueReducer;